"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmahaOptions = void 0;
// OmahaOptions.tsx
//
//  Game Options for the Omaha game.
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.OmahaOptions = {
    versions: [
        {
            title: "9 Card",
            description: "4 Player Cards, | 5 Community Cards",
            value: CardVersionSetting_1.CardVersionSetting.NINE_CARD,
            default: true,
            flavor: 9,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighOnlyDefault, defaultOptions_1.winnerLowOnly, defaultOptions_1.winnerHighLowSplit],
    options: [defaultOptions_1.optionNoneDefault],
    wildcards: [
        defaultOptions_1.wildcardNoneDefault,
        defaultOptions_1.wildcardLowHole,
        defaultOptions_1.wildcardDeuces,
        defaultOptions_1.wildcardOneEyedJacks,
    ],
};
//# sourceMappingURL=OmahaOptions.js.map